var map = {
	"./flag_AU_tab.png": "4f18",
	"./flag_CA_tab.png": "f497",
	"./flag_GB_tab.png": "9a8c",
	"./flag_IE_tab.png": "31f6",
	"./flag_JP_tab.png": "c07b",
	"./flag_KR_tab.png": "8964",
	"./flag_MY_tab.png": "b28a",
	"./flag_NZ_tab.png": "2d6a",
	"./flag_OTHER_tab.png": "bdd2",
	"./flag_SG_tab.png": "ae9e",
	"./flag_UK_tab.png": "d7f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ea87";